module.exports = __webpack_public_path__ + "img/rightcalf-mesomorph-male.9ec7a867.svg";